function e(e){return e instanceof SVGElement&&"svg"!==e.tagName}export{e as isSVGElement};
